class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const targetStr = this.dataset.target;
    if (!targetStr) return;

    this.daysGroup  = this.querySelector('[data-countdown-days]');
    this.secsGroup  = this.querySelector('[data-countdown-seconds]');
    this.daysTens   = this.querySelector('[data-days-tens]');
    this.daysOnes   = this.querySelector('[data-days-ones]');
    this.hoursTens  = this.querySelector('[data-hours-tens]');
    this.hoursOnes  = this.querySelector('[data-hours-ones]');
    this.minsTens   = this.querySelector('[data-mins-tens]');
    this.minsOnes   = this.querySelector('[data-mins-ones]');
    this.secsTens   = this.querySelector('[data-secs-tens]');
    this.secsOnes   = this.querySelector('[data-secs-ones]');

    this.target = new Date(targetStr + 'T23:59:59');

    this.tick();
    this._interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  pad(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  setDigits(tensEl, onesEl, value) {
    const str = this.pad(value);
    tensEl.textContent = str[0];
    onesEl.textContent = str[1];
  }

  tick() {
    const diff = this.target - new Date();

    if (diff <= 0) {
      this.setDigits(this.hoursTens, this.hoursOnes, 0);
      this.setDigits(this.minsTens, this.minsOnes, 0);
      this.setDigits(this.secsTens, this.secsOnes, 0);
      this.daysGroup.classList.add('countdown__group--hidden');
      clearInterval(this._interval);
      return;
    }

    const total   = Math.floor(diff / 1000);
    const days    = Math.floor(total / 86400);
    const hours   = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    const lastDay = days === 0;
    this.daysGroup.classList.toggle('countdown__group--hidden', lastDay);
    this.secsGroup.classList.toggle('countdown__group--hidden', !lastDay);

    this.setDigits(this.daysTens, this.daysOnes, days);
    this.setDigits(this.hoursTens, this.hoursOnes, hours);
    this.setDigits(this.minsTens, this.minsOnes, minutes);
    this.setDigits(this.secsTens, this.secsOnes, seconds);
  }
}

customElements.define('countdown-timer', CountdownTimer);